import { html } from 'lit';
import { CalendarCog } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-calendar-cog')
export class PdsIconCalendarCog extends PdsIcon {
  @state()
  icon = CalendarCog;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
